// Screw photos from the Rothoblaas catalog (head on the left, tip on the right, transparent PNG), keyed by the exact
// screw family name as stored in screw_connector.screw_families.name. Not stored in the DB (ScrewFamily has no image
// field): local files under public/screwConnector.

export const SCREW_FAMILY_IMG: Record<string, string> = {
  HBS: "/screwConnector/hbs.png",
  "HBS EVO": "/screwConnector/hbs-evo.png",
  "HBS EVO C5": "/screwConnector/hbs-evo-c5.png",
  "HBS HARDWOOD": "/screwConnector/hbs-hardwood.png",
  "HBS PLATE": "/screwConnector/hbs-plate.png",
  "HBS PLATE A4": "/screwConnector/hbs-plate-a4.png",
  "HBS PLATE EVO": "/screwConnector/hbs-plate-evo.png",
  LBS: "/screwConnector/lbs.png",
  "LBS EVO": "/screwConnector/lbs-evo.png",
  "LBS HARDWOOD": "/screwConnector/lbs-hardwood.png",
  "LBS HARDWOOD EVO": "/screwConnector/lbs-hardwood-evo.png",
  TBS: "/screwConnector/tbs.png",
  "TBS EVO": "/screwConnector/tbs-evo.png",
  "TBS EVO C5": "/screwConnector/tbs-evo-c5.png",
  "TBS FRAME": "/screwConnector/tbs-frame.png",
  "TBS MAX": "/screwConnector/tbs-max.png",
  VGS: "/screwConnector/vgs.png",
  "VGS A4": "/screwConnector/vgs-a4.png",
  "VGS EVO": "/screwConnector/vgs-evo.png",
  "VGS EVO C5": "/screwConnector/vgs-evo-c5.png",
  "VGS PLATE": "/screwConnector/vgs-plate.png",
  VGZ: "/screwConnector/vgz.png",
  "VGZ EVO": "/screwConnector/vgz-evo.png",
  "VGZ EVO C5": "/screwConnector/vgz-evo-c5.png",
  "VGZ HARDWOOD": "/screwConnector/vgz-hardwood.png",
};

export const screwFamilyImage = (family: string | null | undefined): string | undefined =>
  family ? SCREW_FAMILY_IMG[family] : undefined;
